define([
  'jsx!launcher/views/listbuilder/wysiwyg/components/Text',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Html',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Button',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Image',
  'jsx!launcher/views/listbuilder/wysiwyg/components/TextField',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Checkbox',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Dropdown',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Radio',
  'jsx!launcher/views/listbuilder/wysiwyg/components/CheckboxGroup',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Hidden',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Countdown',
  'jsx!launcher/views/listbuilder/wysiwyg/components/SocialButton',
  'jsx!launcher/views/listbuilder/wysiwyg/components/GridRow',
  'jsx!launcher/views/listbuilder/wysiwyg/components/GridColumn',
  'jsx!launcher/views/listbuilder/wysiwyg/components/ScaledStage',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Discount',
  'jsx!launcher/views/listbuilder/wysiwyg/components/game/Game',
  'jsx!launcher/views/listbuilder/wysiwyg/components/ProgressBar',
  'jsx!launcher/views/listbuilder/wysiwyg/components/ChipDivider',
  'jsx!launcher/views/listbuilder/wysiwyg/components/SocialProofSVG',
], (
  Text,
  Html,
  Button,
  Image,
  TextField,
  Checkbox,
  Dropdown,
  Radio,
  CheckboxGroup,
  Hidden,
  Countdown,
  SocialButton,
  GridRow,
  GridColumn,
  ScaledStage,
  Discount,
  Game,
  ProgressBar,
  ChipDivider,
  SocialProofSVG,
) => ({
  Text,
  Html,
  Button,
  Image,
  TextField,
  Checkbox,
  Dropdown,
  Radio,
  CheckboxGroup,
  Hidden,
  Countdown,
  SocialButton,
  GridRow,
  GridColumn,
  ScaledStage,
  Discount,
  Game,
  ProgressBar,
  ChipDivider,
  SocialProofSVG,
}));
